import { render, staticRenderFns } from "./SubjectFilterTag.vue?vue&type=template&id=6ce74ff0&"
import script from "./SubjectFilterTag.vue?vue&type=script&setup=true&lang=js&"
export * from "./SubjectFilterTag.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports